// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"f0e212d1","787":"79717e89"}[chunkId] + ".chunk.js";
};